// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__v9PJV","img":"login_img__s9sSp","form":"login_form__lgSYU","registerText":"login_registerText__pSvdG"};